import React from 'react'

import NovSarInfoSection from './NovSarInfoSection'
import AssignmentDescriptionSection from './AssignmentDescriptionSection'
import PropertyInfoSection from './PropertyInfoSection'
import AppraisalInfoSection from './AppraisalInfoSection'
import NewProposedConstructionSection from './NewProposedConstructionSection'
import RequesterInfoSection from './RequesterInfoSection'
import BorrowerSection from './BorrowerSection'
import OtherInformationSection from './OtherInformationSection'

const ieDownload = (base64String, name) => {
  if (navigator.msSaveOrOpenBlob) {
    const byteArray = Uint8Array.from(atob(base64String).split('').map(char => char.charCodeAt(0)))
    return navigator.msSaveOrOpenBlob(new Blob([byteArray], { type: 'application/pdf' }), name)
  }
}

export const AssignmentDetails = ({ assignmentDetailPayload }) =>
  <div className='assignment-details'>
    <a download={`${assignmentDetailPayload.lin}AssignmentDetails.pdf`} 
    onClick={() => ieDownload(assignmentDetailPayload.assignmentDetailsPdfBase64Encoded, `${assignmentDetailPayload.lin}AssignmentDetails.pdf`)}
    href={`data:application/octet-stream;base64,${assignmentDetailPayload.assignmentDetailsPdfBase64Encoded}`}>View/Print</a>
    <div className='usa-width-one-whole'>
      <div className='usa-width-one-half'>
        <AssignmentDescriptionSection assignmentDetails={assignmentDetailPayload} />
        <AppraisalInfoSection assignmentDetails={assignmentDetailPayload} />
      </div>
      <div className='usa-width-one-half'>
        <NovSarInfoSection assignmentDetails={assignmentDetailPayload} />
        <RequesterInfoSection assignmentDetails={assignmentDetailPayload} />
      </div>
    </div>
    <div className='usa-width-one-whole'>
      <BorrowerSection assignmentDetails={assignmentDetailPayload} />
      <PropertyInfoSection assignmentDetails={assignmentDetailPayload} />
      <NewProposedConstructionSection assignmentDetails={assignmentDetailPayload} />
      <OtherInformationSection assignmentDetails={assignmentDetailPayload} />
    </div>
  </div>

export default AssignmentDetails
